import React, {useEffect} from 'react';

import FormRow from "../../../../Components/HorizontalForm/FormRow";
import VisitorNameInput from "../../../Visitors/BookingForm/Inputs/VisitorNameInput";
import OptionalFormRow from "../../../../Components/HorizontalForm/OptionalFormRow";


export const defaultVisitor = {
    id: 0,
    name: '',
    email: '',
    company: '',
    _isCollapsed: false,
};

const VisitorFormGroup = (props) => {
    const handleUpdate = (name, value, index) => {
        props.onUpdate(name, value, index);
    }

    return (<>
        <FormRow
            label="Visitor Name"
            required
            errorMessage={props.errors.name}
        >
            <VisitorNameInput
                index={props.index}
                value={props.visitor.name}
                onChange={ handleUpdate }
            />
        </FormRow>


        <FormRow
            label="Email"
            errorMessage={props.errors.email}
            tooltip="Provide visitor email to send them confirmation of the booking"
        >
            <input
                type="email"
                name="email"
                value={props.visitor.email}
                onChange={(e) => handleUpdate(e.target.name, e.target.value, props.index)}
            />
        </FormRow>


        <OptionalFormRow
            label="Company"
            errorMessage={props.errors.company}
            value={props.visitor.company}
            onHide={(e) => handleUpdate('company', '', props.index)}
        >
            <input
                type="text"
                name="company"
                value={props.visitor.company}
                onChange={(e) => handleUpdate(e.target.name, e.target.value, props.index)}
            />
        </OptionalFormRow>
    </>);
}

VisitorFormGroup.propTypes = {
   
}

VisitorFormGroup.defaultProps = {
    
}

export default VisitorFormGroup;
